import React from 'react'
import { BLOCKS_LIBRARY, EditorBlock } from './types'
import { FormattedMessage } from 'react-intl'
import { TEMPLATE_MESSAGES as M } from '../../templateMessages'

/** El rule marca los template literals en `<style>`: se iza a const (guia 17.18). */
const SIDEBAR_STYLES = `
        .editor-block-sidebar {
            background: #fff;
            border-right: 1px solid #e9ecef;
            padding: 12px;
            overflow-y: auto;
            height: 100%;
            flex-shrink: 0;
        }
        .sidebar-section-title {
            font-size: 0.75rem;
            text-transform: uppercase;
            color: #6c757d;
            letter-spacing: 0.5px;
            margin-bottom: 10px;
            font-weight: 700;
        }
        .blocks-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
        }
        .builder-block-item {
            background: #f8f9fa;
            border: 1px solid #dee2e6;
            border-radius: 6px;
            padding: 15px 10px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s;
        }
        .builder-block-item:hover {
            background: #e9ecef;
            border-color: #ced4da;
            transform: translateY(-2px);
            box-shadow: 0 2px 5px rgba(0,0,0,0.05);
        }
        .builder-block-item .icon {
            font-size: 1.5rem;
            color: #495057;
            margin-bottom: 5px;
        }
        .builder-block-item .label {
            font-size: 0.8rem;
            color: #212529;
            font-weight: 500;
        }
      `

interface EditorBlockSidebarProps {
    onBlockClick: (block: EditorBlock) => void
}

export const EditorBlockSidebar: React.FC<EditorBlockSidebarProps> = ({ onBlockClick }) => {
    const structureBlocks = BLOCKS_LIBRARY.filter(b => b.type === 'structure')
    const componentBlocks = BLOCKS_LIBRARY.filter(b => b.type === 'component')
    const mediaBlocks = BLOCKS_LIBRARY.filter(b => b.type === 'media')

    const renderBlock = (block: EditorBlock) => (
        <div
            key={block.id}
            className="builder-block-item"
            onClick={() => onBlockClick(block)}
            title={block.description}
        >
            <div className="icon">
                <i className={`bi ${block.icon}`}></i>
            </div>
            <div className="label">{block.label}</div>
        </div>
    )

    return (
        <div className="editor-block-sidebar">
            <h6 className="sidebar-section-title"><FormattedMessage {...M.sidebarStructure} /></h6>
            <div className="blocks-grid">
                {structureBlocks.map(renderBlock)}
            </div>

            <h6 className="sidebar-section-title mt-4"><FormattedMessage {...M.sidebarComponents} /></h6>
            <div className="blocks-grid">
                {componentBlocks.map(renderBlock)}
            </div>

            <h6 className="sidebar-section-title mt-4"><FormattedMessage {...M.sidebarMedia} /></h6>
            <div className="blocks-grid">
                {mediaBlocks.map(renderBlock)}
            </div>

            <style>{SIDEBAR_STYLES}</style>
        </div>
    )
}
